(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/bankid-verify/bankid-qrcode.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/bankid-verify/bankid-qrcode.js');
'use strict';

const logger = svs.accountservicesReact.deposit.swedbankExpress.logger;
const Button = svs.ui.ReactButton;
const BankidFooter = svs.accountservicesReact.deposit.swedbankExpress.pages.bankidVerify.components.BankidFooter;
const BankidQrcode = _ref => {
  let onCancel = _ref.onCancel,
    _ref$isDeposit = _ref.isDeposit,
    isDeposit = _ref$isDeposit === void 0 ? false : _ref$isDeposit,
    _ref$qrCode = _ref.qrCode,
    qrCode = _ref$qrCode === void 0 ? '' : _ref$qrCode;
  logger.debug('BankidQrcode: ', qrCode);
  const handleCancel = () => {
    onCancel();
  };
  return React.createElement("div", {
    className: "margin-top-2 align-center"
  }, React.createElement("div", null, "L\xE4s av QR-koden med din BankID-app"), React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement("img", {
    height: "192",
    src: qrCode,
    width: "192"
  })), React.createElement(Button, {
    block: true,
    className: "margin-top-2",
    onClick: handleCancel,
    transparent: true
  }, "Avbryt"), React.createElement(BankidFooter, {
    isDeposit: isDeposit
  }));
};
svs.accountservicesReact.deposit.swedbankExpress.pages.bankidVerify.BankidQrcode = BankidQrcode;

 })(window);